import React from 'react';
import { useNavigate } from 'react-router-dom';

import ButtonCustom from '@/components/common/ui/button';
import { useTranslation } from '@/config/i18n';
import PATH from '@/routes/path';


const GiftTopHeader: React.FC = () => {
  const [t] = useTranslation('');
  const navigate = useNavigate();

  function handleNavigateNew() {
    const pathNew = `${PATH.gift}/${PATH.gift_new}`;

    navigate(pathNew);
  }

  return (
    <>
      <div className="header-top flex items-center justify-between">
        <h2 className="title">
          {t('gift_list.title')}
        </h2>
        <div className="action flex items-center">    
          <ButtonCustom className="ml-5" onClick={() => handleNavigateNew()}>
            <span className="flex relative items-center">
              <span className="pi pi-plus mr-2" />
              <span>{t('gift_list.new')}</span>
            </span>
          </ButtonCustom>
        </div>
      </div>
    </>
  );
};

export default GiftTopHeader;
